/* eslint-disable react/prop-types */
import ArgonBox from "components/ArgonBox";
import ArgonTypography from "components/ArgonTypography";
import ArgonButton from "components/ArgonButton";
import ArgonBadge from "components/ArgonBadge";
import Tooltip from "@mui/material/Tooltip";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { Link } from "react-router-dom";

const TYPE_LABEL = {
  NOTES: "Notes",
  EXAM_PAPER: "Exam Paper",
  QUIZ: "Quiz",
  SYLLABUS: "Syllabus",
  TIMETABLE: "Timetable",
};

const visibilityColor = {
  LIVE: "success",
  SCHEDULED: "warning",
  HIDDEN: "secondary",
  DRAFT: "info",
};

const typeColor = {
  NOTES: "info",
  QUIZ: "primary",
  EXAM_PAPER: "error",
  SYLLABUS: "success",
  TIMETABLE: "warning",
};

const audienceLabel = (item) => {
  if (item.audienceType === "ALL") return "All parents";
  if (item.audienceType === "STUDENTS") return "Selected students";
  if (item.audienceType === "SESSIONS") return "Selected classes";
  return [item.classId?.name, item.boardId?.name, item.subjectId?.name].filter(Boolean).join(" · ") || "Class";
};

const StudyHubTableData = (items, onView, onStatus, onDelete) => ({
  columns: [
    { name: "sno", align: "center" },
    { name: "Title", align: "left" },
    { name: "Type", align: "center" },
    { name: "Audience", align: "left" },
    { name: "Status", align: "center" },
    { name: "Views", align: "center" },
    { name: "Action", align: "center" },
  ],
  rows: items.map((item, index) => ({
    sno: (
      <ArgonTypography variant="caption" color="text" fontWeight="medium">
        {index + 1}
      </ArgonTypography>
    ),
    Title: (
      <ArgonBox>
        <ArgonTypography variant="caption" color="text" fontWeight="medium">
          {item.title}
        </ArgonTypography>
        {item.chapter ? (
          <ArgonTypography variant="caption" color="secondary" display="block">
            {item.chapter}
          </ArgonTypography>
        ) : null}
      </ArgonBox>
    ),
    Type: (
      <ArgonBadge
        variant="gradient"
        badgeContent={TYPE_LABEL[item.type] || item.type}
        color={typeColor[item.type] || "secondary"}
        size="xs"
        container
      />
    ),
    Audience: (
      <ArgonTypography variant="caption" color="text" fontWeight="medium">
        {audienceLabel(item)}
      </ArgonTypography>
    ),
    Status: (
      <ArgonBadge
        variant="gradient"
        badgeContent={item.visibility || item.status}
        color={visibilityColor[item.visibility] || "secondary"}
        size="xs"
        container
      />
    ),
    Views: (
      <ArgonTypography variant="caption" color="text" fontWeight="medium">
        {item.viewCount || 0}
      </ArgonTypography>
    ),
    Action: (
      <ArgonBox display="flex" alignItems="center" justifyContent="center" gap={0.5}>
        <Tooltip title="Open file">
          <ArgonButton variant="text" color="info" size="small" sx={{ minWidth: "32px", p: 0.5 }} onClick={() => onView(item)}>
            <VisibilityIcon fontSize="small" />
          </ArgonButton>
        </Tooltip>
        <ArgonButton
          variant="outlined"
          size="small"
          color={item.visibility === "LIVE" ? "warning" : "success"}
          onClick={() => onStatus(item)}
          sx={{ minWidth: 78, px: 1.25 }}
        >
          {item.visibility === "LIVE" ? "Hide" : "Publish"}
        </ArgonButton>
        <Tooltip title="Edit">
          <ArgonButton
            variant="text"
            color="primary"
            size="small"
            component={Link}
            to={`/study-hub/edit/${item._id}`}
            sx={{ minWidth: "32px", p: 0.5 }}
          >
            <EditIcon fontSize="small" />
          </ArgonButton>
        </Tooltip>
        <Tooltip title="Delete">
          <ArgonButton variant="text" color="error" size="small" sx={{ minWidth: "32px", p: 0.5 }} onClick={() => onDelete(item._id)}>
            <DeleteIcon fontSize="small" />
          </ArgonButton>
        </Tooltip>
      </ArgonBox>
    ),
  })),
});

export default StudyHubTableData;
